import { render } from "./MainDetailClear.vue?vue&type=template&id=e6fe2a16&scoped=true"
import script from "./MainDetailClear.vue?vue&type=script&lang=js"
export * from "./MainDetailClear.vue?vue&type=script&lang=js"

import "./MainDetailClear.vue?vue&type=style&index=0&id=e6fe2a16&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6fe2a16"]])

export default __exports__